import { Navigate } from 'react-router-dom';

/**
 * ダッシュボードコンポーネント
 * ログイン後「アナリティクス画面」へリダイレクトします
 */
export const Dashboard = () => {
  return <Navigate to="/sales" replace />;
};

export default Dashboard;
